import { WorkflowConstants } from "lookup/WorkflowConstants";
import { RawConstants } from "lookup/RawConstants";

/**
 * @typedef {object} FaxDispositionActionVisibilityContext
 * @property {object} formValues
 * @property {object} rawDetails
 * @property {object} [selectableDispositions]
 * @property {boolean} [contextIsRaw]
 * @property {boolean} [changeDisposition]
 * @property {boolean} [disableActions]
 * @property {boolean} [submittingDisposition]
 */

/** @param {FaxDispositionActionVisibilityContext} _context */
export const showAlways = () => true;

/** @param {FaxDispositionActionVisibilityContext} context */
export const showWhenDeclinedDisposition = ({
  formValues,
  rawDetails,
  selectableDispositions,
}) =>
  formValues.disposition === selectableDispositions?.DECLINED ||
  rawDetails.disposition?.disposition === "DECLINED";

/** @param {FaxDispositionActionVisibilityContext} context */
export const showWhenSubmittedViaEhr = ({ rawDetails }) =>
  rawDetails.wfItemStatus === WorkflowConstants.SUBMITTED_VIA_EHR;

/** @param {FaxDispositionActionVisibilityContext} context */
export const showWhenNotRawConfirmed = ({ rawDetails, changeDisposition }) =>
  rawDetails.status !== RawConstants.status.CONFIRMED || changeDisposition;

/**
 * @param {string} actionKey
 * @param {Record<string, (context: FaxDispositionActionVisibilityContext) => boolean>} [actionVisibility]
 * @param {FaxDispositionActionVisibilityContext} context
 */
export const isFaxDispositionActionVisible = (
  actionKey,
  actionVisibility,
  context
) => {
  const isVisible = actionVisibility?.[actionKey];

  if (!isVisible) {
    return true;
  }

  return isVisible(context);
};
